import { UserEmailRequestAjax } from './user-email-request.backend-model';
import { UserEmailRequest } from './user-email-request.model';

export function transformUserEmailRequest(
  request: UserEmailRequestAjax,
): UserEmailRequest {
  const { id, email, ip_address, status } = request;

  return {
    id,
    email,
    ipAddress: ip_address,
    status,
  };
}
